import { Link } from "react-router-dom";
import { hotEvents } from "@/mocks/events";
import { SectionHeading, TrendBadge } from "@/components/base/Shared";
import { formatHeat } from "@/utils/format";
import Reveal from "@/components/base/Reveal";

export default function CaseGrid() {
  const cases = hotEvents.slice(1, 5);

  return (
    <section id="cases" className="bg-background-100 border-y border-background-200 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="CASE STUDY"
          title="典型案例：四种不同的传播结构"
          desc="同样冲上热搜，背后的扩散方式却完全不同。有的靠证据整理，有的靠实时对峙，有的则长时间停在平台议题上。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {cases.map((event, index) => (
            <Reveal key={event.id} delay={index * 80}>
              <article className="group h-full flex flex-col rounded-2xl bg-background-50 border border-background-200 overflow-hidden">
                <Link to={`/event/${event.id}`} className="block">
                  <div className="relative w-full h-44 overflow-hidden">
                    <img
                      src={event.cover}
                      alt={`${event.title}传播路径示意图`}
                      title={`${event.title} · 发酵与扩散追踪`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-background-50/90 text-xs font-label text-foreground-900">
                      {event.category}
                    </span>
                  </div>
                </Link>
                <div className="flex flex-col flex-1 p-5">
                  <Link to={`/event/${event.id}`}>
                    <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
                      {event.title}
                    </h3>
                  </Link>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
                    {event.summary}
                  </p>
                  <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between">
                    <span className="text-xs text-foreground-500">
                      话题量 <strong className="text-foreground-900 font-label">{event.topicCount}万</strong>
                    </span>
                    <TrendBadge trend={event.trend} rate={event.trendRate} />
                  </div>
                  <div className="mt-3 flex items-center justify-between">
                    <span className="font-label text-sm text-primary-600">{formatHeat(event.heat)}</span>
                    <Link
                      to={`/event/${event.id}`}
                      className="inline-flex items-center gap-1 text-xs font-label text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
                    >
                      看传播路径
                      <i className="ri-arrow-right-line" />
                    </Link>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}